import { AssetPreviewAudioController } from './asset-preview-audio.controller'

function assetPreviewAudio () {
  return {
    restrict: 'E',
    scope: {
      template: '=',
      previewFlags: '=',
      location: '<'
    },
    templateUrl: '/core/directives/asset-preview-audio/asset-preview-audio.html?$$REVISION$$',
    controller: AssetPreviewAudioController
  }
}
export { assetPreviewAudio }
